import { ComboRow } from './coremodels';

export const simpleLabel = (x: ComboRow) => `${x.nam||x.recname}`;

export const comboLabel = (x: ComboRow) => `${x.shc||x.shortcode} - ${x.nam||x.recname}`;

export const codeLabel = (x: ComboRow) => `${x.shc||x.shortcode}`;

